import React, { useEffect, useRef, useState } from "react";
import { Form, Col } from "react-bootstrap";
import SectionRow from "components/PantallasEdit/SectionRow/SectionRow";
import EditContainer from "components/PantallasEdit/EditContainer/EditContainer";
import InputContainer from "components/PantallasEdit/InputContainer/InputContainer";
import { ClienteManager } from "managers";
import EditSection from "components/PantallasEdit/EditSection/EditSection";
import useMessage from "hooks/useMessage";
import useExceptionHandler from "hooks/useExceptionHandler";
import Select from "react-select";
import { Cliente } from "models/ECF/Cliente";
import { RncLookup, Simplebar } from "components";

export default function ClienteEdit({
  showLoading,
  hideLoading,
  IdSec = undefined,
  showCanvas,
  setShowCanvas,
  updateList = () => {},
  onCreated = () => {},
}) {
  const [esNuevo, setEsNuevo] = useState(!IdSec);
  const [cliente, setCliente] = useState({});
  const [tituloHeader, setTituloHeader] = useState("Crear Cliente");
  const ref = useRef(null);
  const { Message, cerrarAlertas } = useMessage();
  const { handleException } = useExceptionHandler();

  useEffect(() => {
    if (IdSec) {
      showLoading();
      cargarCliente(IdSec);
      setTituloHeader("Editar Cliente");
    } else {
      setDefaultValues();
      setTituloHeader("Crear Cliente");
    }
    hideLoading();
    cerrarAlertas();
    return () => {
      hideLoading();
      cerrarAlertas();
    };
  }, [IdSec]);

  const setDefaultValues = () => {
    setCliente({
      Documento: "",
      RazonSocial: "",
      Contacto: "",
      Correo: "",
      Direccion: "",
      CodigoInterno: "",
      TipoDocumento: "",
      Tipo: "",
      Estatus: Cliente.DEFAULT_ESTATUS_VALUE,
    });
  };

  const cargarCliente = (id) => {
    showLoading();
    ClienteManager.buscarPorId(id)
      .then((data) => {
        if (data && data.IdSec) {
          setCliente(data);
        } else {
          Message({ message: "Cliente no encontrado", type: "error" });
        }
      })
      .catch((e) => handleException(e))
      .finally(() => {
        hideLoading();
        updateList();
      });
  };

  function grabar() {
    showLoading();

    if (esNuevo) {
      ClienteManager.crear(cliente)
        .then((res) => {
          Message({ message: `Grabado Exitosamente` });
          onCreated(res);
          setDefaultValues();
          setShowCanvas(false);
        })
        .catch((e) => handleException(e))
        .finally(() => {
          hideLoading();
          updateList();
        });
    } else {
      ClienteManager.actualizar(cliente)
        .then((res) => {
          Message({ message: `Actualizado Exitosamente` });
          setDefaultValues();
          setShowCanvas(false);
        })
        .catch((e) => handleException(e))
        .finally(() => {
          hideLoading();
          updateList();
        });
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCliente({
      ...cliente,
      [name]: value,
    });
  };

  return (
    <Simplebar
      ref={ref}
      backdrop={"static"}
      confirmBack
      placement={"end"}
      size="xxl"
      portal={false}
      visible={showCanvas}
      setShow={(e) => {
        setShowCanvas(e);
      }}
      useLoading={true}
      title={tituloHeader}
      btnLeft={{
        show: true,
        message: "Grabar",
        isComponent: true,
        size: "45px",
        height: "24px",
        with: "24px",
        iconName: "save",
        isCenter: true,
        func: grabar,
      }}
      btnRight={{
        show: false,
        label: "Grabar",
        func: () => {},
      }}
    >
      <Col>
        <Form action="" className="form-horizontal" method="">
          <EditContainer>
            <EditSection title="Información del Cliente">
              <SectionRow>
                <InputContainer label="Tipo Documento" labelClassName={"d-flex"} required={true}>
                  <Select
                    className="react-select primary"
                    classNamePrefix="react-select"
                    name="TipoDocumento"
                    options={Cliente.TIPO_DOCUMENTO_LIST}
                    value={
                      cliente.TipoDocumento
                        ? Cliente.TIPO_DOCUMENTO_LIST.find(
                            (option) => option.value === cliente.TipoDocumento
                          )
                        : null
                    }
                    onChange={(selectedOption) => {
                      setCliente({
                        ...cliente,
                        TipoDocumento: selectedOption ? selectedOption.value : "",
                      });
                    }}
                    placeholder="Seleccione Tipo Documento"
                    isClearable
                  />
                </InputContainer>
                <InputContainer label="Documento" labelClassName={"d-flex"} required={true}>
                  <RncLookup
                    initialValue={{
                      value: cliente.Documento,
                      label: cliente.Documento,
                      Rnc: cliente.Documento,
                      RazonSocial: cliente.RazonSocial,
                    }}
                    onChange={(e) => {
                      setCliente({
                        ...cliente,
                        Documento: e.Rnc,
                        RazonSocial: e.RazonSocial,
                      });
                    }}
                  />
                </InputContainer>
              </SectionRow>

              <SectionRow>
                <InputContainer label="Nombre" labelClassName={"d-flex"} required={true}>
                  <Form.Control
                    type="text"
                    name="RazonSocial"
                    value={cliente.RazonSocial || ""}
                    onChange={handleChange}
                    placeholder="Razón Social"
                  />
                </InputContainer>
                <InputContainer label="Tipo Comprobante" labelClassName={"d-flex"} required={true}>
                  <Select
                    className="react-select primary"
                    classNamePrefix="react-select"
                    name="Tipo"
                    options={Cliente.TIPO_COMPROBANTE_LIST}
                    value={
                      cliente.Tipo
                        ? Cliente.TIPO_COMPROBANTE_LIST.find(
                            (option) => option.value === cliente.Tipo
                          )
                        : null
                    }
                    onChange={(selectedOption) => {
                      setCliente({
                        ...cliente,
                        Tipo: selectedOption ? selectedOption.value : "",
                      });
                    }}
                    placeholder="Seleccione Tipo Comprobante"
                    isClearable
                  />
                </InputContainer>
              </SectionRow>

              <SectionRow>
                <InputContainer label="Telefono" labelClassName={"d-flex"}>
                  <Form.Control
                    type="text"
                    name="Contacto"
                    value={cliente.Contacto || ""}
                    onChange={handleChange}
                    placeholder="Telefono"
                  />
                </InputContainer>
                <InputContainer label="Correo Electrónico" labelClassName={"d-flex"}>
                  <Form.Control
                    type="email"
                    name="Correo"
                    value={cliente.Correo || ""}
                    onChange={handleChange}
                    placeholder="Correo Electrónico"
                  />
                </InputContainer>
              </SectionRow>

              <SectionRow>
                <InputContainer label="Dirección" labelClassName={"d-flex"}>
                  <Form.Control
                    type="text"
                    name="Direccion"
                    value={cliente.Direccion || ""}
                    onChange={handleChange}
                    placeholder="Calle, sector, ciudad/provincia, país"
                  />
                </InputContainer>
                <InputContainer label="Código" labelClassName={"d-flex"}>
                  <Form.Control
                    type="text"
                    name="CodigoInterno"
                    value={cliente.CodigoInterno || ""}
                    onChange={handleChange}
                    placeholder="Código Interno"
                  />
                </InputContainer>
              </SectionRow>

              <SectionRow>
                <InputContainer label="Estatus" labelClassName={"d-flex"}>
                  <Select
                    className="react-select primary"
                    classNamePrefix="react-select"
                    name="Estatus"
                    options={Cliente.ESTATUS_LIST}
                    value={Cliente.ESTATUS_LIST.find(
                      (option) =>
                        option.value ===
                        (cliente.Estatus || Cliente.DEFAULT_ESTATUS_VALUE)
                    )}
                    onChange={(selectedOption) => {
                      setCliente({
                        ...cliente,
                        Estatus: selectedOption
                          ? selectedOption.value
                          : Cliente.DEFAULT_ESTATUS_VALUE,
                      });
                    }}
                    isDisabled={esNuevo}
                  />
                </InputContainer>
              </SectionRow>
            </EditSection>
          </EditContainer>
        </Form>
      </Col>
    </Simplebar>
  );
}